import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=027bb932&lang=pug"
import script from "./account-detail.vue?vue&type=script&lang=js"
export * from "./account-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports